import { render, staticRenderFns } from "./bread-crumb.vue?vue&type=template&id=1093ed5f&scoped=true"
import script from "./bread-crumb.vue?vue&type=script&lang=js"
export * from "./bread-crumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1093ed5f",
  null
  
)

export default component.exports